<template>
  <div class="login">
    <div ref="container" class="login-container">
      <el-form
        ref="loginForm"
        v-loading="loading"
        :model="loginForm"
        :rules="loginRules"
        class="login-container-form"
        auto-complete="on"
        label-position="left"
      >
        <p class="login-container-form-title">{{ projectName }}</p>
        <el-form-item class="login-container-form-username" prop="username">
          <el-input
            ref="username"
            class="login-container-form-username-input"
            v-model.trim="loginForm.username"
            placeholder="Username"
            name="username"
            type="text"
            tabindex="1"
            auto-complete="on"
            @keyup.enter.native="handleLogin"
          >
            <template slot="prepend">
              <span class="svg-container">
                <svg-icon icon-class="user" />
              </span>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item class="login-container-form-password" prop="password">
          <el-input
            :key="passwordType"
            class="login-container-form-password-input"
            ref="password"
            v-model="loginForm.password"
            :type="passwordType"
            placeholder="Password"
            name="password"
            tabindex="2"
            auto-complete="on"
            @keyup.enter.native="handleLogin"
          >
            <template slot="prepend">
              <span class="svg-container">
                <svg-icon icon-class="password" />
              </span>
            </template>
            <template slot="append">
              <span class="show-pwd" @click="showPwd">
                <svg-icon
                  :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'"
                />
              </span>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item class="login-container-form-captcha" prop="captcha">
          <el-input
            class="login-container-form-captcha-input"
            v-model="loginForm.captcha"
            type="text"
            placeholder="验证码"
            @keyup.enter.native="handleLogin"
          >
            <template slot="prepend">
              <span class="svg-container">
                <svg-icon icon-class="component" />
              </span>
            </template>
            <template slot="append">
              <img
                class="login-container-form-captcha-code"
                :src="captchaImg"
                @click="refreshCaptcha()"
              />
            </template>
          </el-input>
        </el-form-item>

        <el-button
          class="login-container-form-submit"
          :loading="loading"
          type="primary"
          @click.native.prevent="handleLogin"
        >
          Login
        </el-button>

        <!-- <div class="tips">
          <span style="margin-right: 20px" />
        </div> -->
      </el-form>
    </div>
  </div>
</template>

<script>
import { validUsername } from "@/utils/validate";
import { config, getCaptcha } from "@/api/user";

export default {
  name: "Login",
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error("请输入正确的用户账号"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("密码不可小于6位数"));
      } else {
        callback();
      }
    };
    return {
      captchaImg: "",
      loginForm: {
        username: "",
        password: "",
        captcha: "",
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword },
        ],
        captcha: [{ required: true, trigger: "blur", message: "请输入验证码" }],
      },
      loading: false,
      passwordType: "password",
      redirect: undefined,
    };
  },
  computed: {
    projectName: {
      get() {
        return this.$store.state.settings.projectName;
      },
      set(val) {
        this.$store.dispatch("settings/changeName", val);
      },
    },
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
    this.getProjectTitle();
    this.refreshCaptcha();
    var el_message_box = document.querySelector(".el-message-box__wrapper");
    var v_modal = document.querySelector(".v-modal");
    if (el_message_box && v_modal) {
      el_message_box.parentNode.removeChild(el_message_box);
      v_modal.parentNode.removeChild(v_modal);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.container.style.right = "25%";
    });
  },
  methods: {
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },

    /**
     * 获取验证码信息
     */
    refreshCaptcha() {
      // 刷新验证码
      getCaptcha().then((res) => {
        if (res.data) {
          if (res.data.captchaBase64) {
            this.captchaImg = res.data.captchaBase64;
          }
        }
      });
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          const param = {
            username: this.loginForm.username,
            password: this.loginForm.password,
            captcha: this.loginForm.captcha,
          };
          this.loading = true;
          this.$store
            .dispatch("user/login", param)
            .then((data) => {
              this.$router.push({ path: this.redirect || "/" });
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
              // 刷新验证码
              this.refreshCaptcha();
            });
        } else {
          return false;
        }
      });
    },
    getProjectTitle() {
      config().then((response) => {
        this.projectTitle = response.data.projectTitle;
        this.$store.dispatch("settings/changeName", this.projectTitle);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>